import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para estados do julgamento do processo.
 *
 * @readonly
 * @enum {Object}
 */
export const ESTADO_JULGAMENTO_PROCESSO = {
    DESCONHECIDO: {
        id: 'DESCONHECIDO',
        descricao: 'Não informado',
        codigo: 'DESCONHECIDO'
    },
    AGUARDANDO_INICIO_JULGAMENTO_VIRTUAL: {
        id: 'AGUARDANDO_INICIO_JULGAMENTO_VIRTUAL',
        descricao: 'Aguardando julgamento virtual',
        codigo: 'AGUARDANDO_INICIO_JULGAMENTO_VIRTUAL'
    },
    EM_JULGAMENTO_VIRTUAL: {
        id: 'EM_JULGAMENTO_VIRTUAL',
        descricao: 'Em julgamento virtual',
        codigo: 'EM_JULGAMENTO_VIRTUAL'
    },
    JULGAMENTO_EXCLUSIVAMENTE_VIRTUAL_FINALIZADO: {
        id: 'JULGAMENTO_EXCLUSIVAMENTE_VIRTUAL_FINALIZADO',
        descricao: 'Julgamento exclusivamente virtual finalizado',
        codigo: 'JULGAMENTO_EXCLUSIVAMENTE_VIRTUAL_FINALIZADO'
    },
    JULGAMENTO_VIRTUAL_FINALIZADO: {
        id: 'JULGAMENTO_VIRTUAL_FINALIZADO',
        descricao: 'Julgamento virtual finalizado',
        codigo: 'JULGAMENTO_VIRTUAL_FINALIZADO'
    },
    AGUARDANDO_SESSAO_JULGAMENTO_PRESENCIAL_VINCULADA: {
        id: 'AGUARDANDO_SESSAO_JULGAMENTO_PRESENCIAL_VINCULADA',
        descricao: `Aguardando sessão de julgamento presencial vinculada`,
        codigo: 'AGUARDANDO_SESSAO_JULGAMENTO_PRESENCIAL_VINCULADA'
    },
    AGUARDANDO_SESSAO_JULGAMENTO_PRESENCIAL: {
        id: 'AGUARDANDO_SESSAO_JULGAMENTO_PRESENCIAL',
        descricao: `Aguardando sessão de julgamento presencial`,
        codigo: 'AGUARDANDO_SESSAO_JULGAMENTO_PRESENCIAL'
    },
    EM_JULGAMENTO_PRESENCIAL: {
        id: 'EM_JULGAMENTO_PRESENCIAL',
        descricao: `Em julgamento presencial`,
        codigo: 'EM_JULGAMENTO_PRESENCIAL'
    },
    JULGAMENTO_PRESENCIAL_FINALIZADO: {
        id: 'JULGAMENTO_PRESENCIAL_FINALIZADO',
        descricao: 'Julgamento finalizado',
        codigo: 'JULGAMENTO_PRESENCIAL_FINALIZADO'
    }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de estados de julgamento do processo.
 * @readonly
 */
export default class EstadoJulgamentoProcesso {
    static idDescricaoBase = new SituacaoIdDescricaoBase(ESTADO_JULGAMENTO_PROCESSO);

    static getDescricao(id) {
        return EstadoJulgamentoProcesso.idDescricaoBase.getDescricao(id);
    }

    static getCodigo(id) {
        return EstadoJulgamentoProcesso.idDescricaoBase.getValorPropriedade(id, 'codigo');
    }

    static getItemByCodigo(codigo) {
        return EstadoJulgamentoProcesso.idDescricaoBase.getObjectByProperty('codigo', codigo);
    }

    static getIdByCodigo(codigo) {
        const obj = EstadoJulgamentoProcesso.getItemByCodigo(codigo);
        return obj ? obj.id : '';
    }

    static getDescricaoByCodigo(codigo) {
        return EstadoJulgamentoProcesso.getDescricao(EstadoJulgamentoProcesso.getIdByCodigo(codigo));
    }
}
